import React, { useState } from "react";
import ConfirmDialog from "../../../components/ConfirmDialog/ConfirmDialog";
import Toast from "../../../components/support/Toast";
import usePatientExport from "./usePatientExport";

/**
 * Diálogo "Exportar dados deste paciente" (LGPD) da ficha.
 * Aberto pelo painel "Privacidade e dados" da aba Dados pessoais
 * (PatientPrivacyPanel), que só aparece para o dono da clínica. Fica sempre montado para o Toast sobreviver ao fechamento.
 * Especificação: docs/features/lgpd-eliminacao/README.md
 */
function PatientExportDialog({ patientId, open, onClose }) {
    const [toast, setToast] = useState({ open: false, message: "", severity: "error" });
    const { exporting, exportNow } = usePatientExport(patientId);

    const showToast = (message, severity = "error") => {
        setToast({ open: true, message, severity });
    };

    const OnConfirmHandler = async () => {
        const result = await exportNow();

        if (result.success) {
            onClose();
            showToast("Exportação concluída. Guarde o arquivo em local seguro.", "success");
        } else {
            showToast(result.error);
        }
    };

    return (
        <>
            <ConfirmDialog
                isOpen={open}
                variant="info"
                title="Exportar dados deste paciente"
                message="Vamos gerar um arquivo ZIP com tudo o que a clínica tem deste paciente: cadastro, prontuário, agendamentos, financeiro, anexos e fotos. É este arquivo que a clínica deve guardar caso depois anonimize ou exclua o paciente."
                confirmLabel="Exportar"
                loading={exporting}
                onConfirm={OnConfirmHandler}
                onCancel={() => { if (!exporting) onClose(); }}
            />

            <Toast
                open={toast.open}
                message={toast.message}
                severity={toast.severity}
                onClose={() => setToast((current) => ({ ...current, open: false }))}
            />
        </>
    );
}

export default PatientExportDialog;
